<template>
	<div class="orders-list-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-left">
				<div class="header-icon">
					<svg viewBox="0 0 24 24">
						<path d="M19,7H22V9H19V12H17V9H14V7H17V4H19V7M12,2C13.1,2 14,2.9 14,4V5H20V7H4V5H10V4C10,2.9 10.9,2 12,2M4,8H20V19C20,20.1 19.1,21 18,21H6C4.9,21 4,20.1 4,19V8M6,10V19H18V10H6Z"/>
					</svg>
				</div>
				<div class="header-info">
					<h1>订单管理</h1>
					<p>管理系统订单信息，包含订单详情、支付状态、物流跟踪等功能</p>
				</div>
			</div>
			<div class="header-actions">
				<el-button type="primary" icon="el-icon-plus" @click="addOrUpdateHandler()" v-if="isAuth('orders'+'/'+orderStatus,'新增')">
					新建订单
				</el-button>
			</div>
		</div>

		<!-- 筛选区域 -->
		<div class="filter-section">
			<el-card>
				<el-form :inline="true" :model="searchForm" class="search-form">
					<el-form-item label="订单编号">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
									</svg>
								</div>
								<el-input v-model="searchForm.orderid" placeholder="请输入订单编号" clearable></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="商品名称">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11.03L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11.03C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
									</svg>
								</div>
								<el-input v-model="searchForm.goodname" placeholder="请输入商品名称" clearable></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search()" icon="el-icon-search">查询</el-button>
						<el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
					</el-form-item>
				</el-form>
			</el-card>
		</div>

		<!-- 工具栏 -->
		<div class="toolbar-section" v-if="dataListSelections.length > 0">
			<el-card>
				<div class="toolbar-content">
					<span class="selection-info">已选择 {{ dataListSelections.length }} 项</span>
					<div class="toolbar-actions">
						<el-button type="danger" @click="deleteHandler()" v-if="isAuth('orders'+'/'+orderStatus,'删除')">
							<i class="el-icon-delete"></i>
							批量删除
						</el-button>
					</div>
				</div>
			</el-card>
		</div>

		<!-- 统计和导出工具栏 -->
		<div class="stats-toolbar">
			<el-card>
				<div class="stats-content">
					<div class="stats-actions">
						<download-excel v-if="isAuth('orders'+'/'+orderStatus,'导出')" class="export-excel-wrapper" :data="dataList" :fields="json_fields" name="订单.xls">
							<el-button type="warning" icon="el-icon-download">导出Excel</el-button>
						</download-excel>
						
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'日销量')" type="info" @click="dayNumberChartDialog()">日销量</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'月销量')" type="info" @click="monthNumberChartDialog()">月销量</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'年销量')" type="info" @click="yearNumberChartDialog()">年销量</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'品销量')" type="info" @click="goodnameNumberChartDialog()">商品销量</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'类销量')" type="info" @click="goodtypeNumberChartDialog()">类型销量</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'日销额')" type="success" @click="dayAmountChartDialog()">日销额</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'月销额')" type="success" @click="monthAmountChartDialog()">月销额</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'年销额')" type="success" @click="yearAmountChartDialog()">年销额</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'品销额')" type="success" @click="goodnameAmountChartDialog()">商品销额</el-button>
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'类销额')" type="success" @click="goodtypeAmountChartDialog()">类型销额</el-button>
						
						<!-- 微信小程序同步功能 -->
						<el-button v-if="isAuth('orders'+'/'+orderStatus,'同步')" type="warning" @click="syncToWechatMiniProgram()" icon="el-icon-refresh">
							同步到微信小程序
						</el-button>
					</div>
				</div>
			</el-card>
		</div>

		<!-- 表格区域 -->
		<div class="table-section">
			<el-card>
				<div class="table-header">
					<h3>订单列表</h3>
					<el-button type="text" @click="getDataList()" icon="el-icon-refresh">刷新</el-button>
				</div>
				
				<el-table 
					class="data-table"
					:data="dataList"
					v-loading="dataListLoading"
					@selection-change="selectionChangeHandler"
					v-if="isAuth('orders'+'/'+orderStatus,'查看')"
				>
					<el-table-column type="selection" width="50" align="center"></el-table-column>
					<el-table-column 
						label="序号" 
						type="index" 
						width="80" 
						align="center"
						:index="getTableIndex"
					></el-table-column>
					
					<el-table-column 
						prop="orderid"
						label="订单信息"
						min-width="220"
						show-overflow-tooltip
					>
						<template slot-scope="scope">
							<div class="order-info">
								<div class="order-icon">
									<svg viewBox="0 0 24 24">
										<path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
									</svg>
								</div>
								<div class="order-details">
									<div class="order-number">{{ scope.row.orderid }}</div>
									<div class="order-date" v-if="scope.row.addtime">
										下单时间：{{ formatDate(scope.row.addtime) }}
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						prop="goodname"
						label="商品信息"
						min-width="200"
						show-overflow-tooltip
					>
						<template slot-scope="scope">
							<div class="good-info">
								<div class="good-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11.03L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11.03C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
									</svg>
								</div>
								<div class="good-details">
									<div class="good-name">{{ scope.row.goodname }}</div>
									<div class="good-type" v-if="scope.row.goodtype">
										类型：{{ scope.row.goodtype }}
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="商品图片" 
						width="100" 
						align="center"
					>
						<template slot-scope="scope">
							<div class="product-image">
								<div class="image-preview" v-if="scope.row.picture">
									<img 
										v-if="scope.row.picture.substring(0,4)=='http'" 
										:src="scope.row.picture.split(',')[0]" 
										class="product-img"
										@error="handleImageError"
										@click="previewImage(scope.row.picture.split(',')[0])"
									>
									<img 
										v-else 
										:src="$base.url+scope.row.picture.split(',')[0]" 
										class="product-img"
										@error="handleImageError"
										@click="previewImage($base.url+scope.row.picture.split(',')[0])"
									>
									<div class="image-overlay">
										<i class="el-icon-zoom-in"></i>
									</div>
								</div>
								<div class="no-image" v-else>
									<i class="el-icon-picture-outline"></i>
									<span>暂无图片</span>
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="数量/价格"
						width="120"
						align="center"
					>
						<template slot-scope="scope">
							<div class="quantity-price">
								<div class="quantity">
									<i class="el-icon-goods"></i>
									{{ scope.row.buynumber }}件
								</div>
								<div class="price">
									<span class="price-symbol">¥</span>{{ scope.row.price }}
								</div>
								<div class="discount-price" v-if="scope.row.discountprice && scope.row.discountprice != scope.row.price">
									折扣价：¥{{ scope.row.discountprice }}
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="总价"
						width="100"
						align="center"
					>
						<template slot-scope="scope">
							<div class="total-price">
								<div class="total">¥{{ scope.row.total }}</div>
								<div class="discount-total" v-if="scope.row.discounttotal && scope.row.discounttotal != scope.row.total">
									实付：¥{{ scope.row.discounttotal }}
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="支付方式"
						width="90"
						align="center"
					>
						<template slot-scope="scope">
							<el-tag 
								:type="getPaymentTagType(scope.row.type)"
								size="small"
								class="payment-tag"
							>
								{{ getPaymentText(scope.row.type) }}
							</el-tag>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="订单状态"
						width="100"
						align="center"
					>
						<template slot-scope="scope">
							<el-tag 
								:type="getStatusTagType(scope.row.status)"
								size="small"
								class="status-tag"
							>
								{{ scope.row.status }}
							</el-tag>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="退款状态"
						width="100"
						align="center"
					>
						<template slot-scope="scope">
							<el-tag 
								:type="getRefundStatusTagType(scope.row.refundStatus)"
								size="small"
								class="refund-status-tag"
								v-if="scope.row.refundStatus && scope.row.refundStatus !== '无'"
							>
								{{ scope.row.refundStatus }}
							</el-tag>
							<span v-else class="no-refund">-</span>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="收货信息"
						min-width="180"
						show-overflow-tooltip
					>
						<template slot-scope="scope">
							<div class="shipping-info">
								<div class="consignee">
									<i class="el-icon-user-solid"></i>
									{{ scope.row.consignee }}
								</div>
								<div class="phone" v-if="scope.row.tel">
									<i class="el-icon-phone"></i>
									{{ scope.row.tel }}
								</div>
								<div class="address" v-if="scope.row.address">
									<i class="el-icon-location"></i>
									{{ scope.row.address }}
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="备注"
						width="150"
						show-overflow-tooltip
					>
						<template slot-scope="scope">
							<div class="remark" v-if="scope.row.remark">
								{{ scope.row.remark }}
							</div>
							<span v-else class="no-remark">无备注</span>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="配送信息"
						width="180"
						show-overflow-tooltip
					>
						<template slot-scope="scope">
							<div class="delivery-info">
								<!-- 已发货订单显示配送信息 -->
								<div v-if="scope.row.status === '已发货'">
									<!-- 商家自配送 -->
									<div v-if="scope.row.delivery_type === 'self_delivery'" class="self-delivery">
										<i class="el-icon-shopping-cart-2"></i>
										<span>商家自配送</span>
									</div>
									<!-- 物流运输 -->
									<div v-else-if="scope.row.delivery_type === 'logistics' && scope.row.logistics_company" class="logistics-info">
										<div class="logistics-company">
											<i class="el-icon-office-building"></i>
											<span>{{ scope.row.logistics_company }}</span>
										</div>
										<div class="logistics-number">
											<i class="el-icon-truck"></i>
											<span>{{ scope.row.logistics_number }}</span>
										</div>
									</div>
									<!-- 兼容旧数据：检查logistics字段 -->
									<div v-else-if="scope.row.logistics && scope.row.logistics !== '未发货'" class="logistics-info">
										<div class="logistics-company">
											<i class="el-icon-office-building"></i>
											<span>{{ scope.row.logistics.split(' - ')[0] || '物流公司' }}</span>
										</div>
										<div class="logistics-number">
											<i class="el-icon-truck"></i>
											<span>{{ scope.row.logistics.split(' - ')[1] || scope.row.logistics }}</span>
										</div>
									</div>
									<!-- 默认显示 -->
									<div v-else class="self-delivery">
										<i class="el-icon-shopping-cart-2"></i>
										<span>商家自配送</span>
									</div>
								</div>
								<!-- 未发货订单 -->
								<span v-else class="no-delivery">未发货</span>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column 
						label="操作" 
						width="300" 
						align="center"
						fixed="right"
					>
						<template slot-scope="scope">
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'查看')" type="success" size="mini" @click="addOrUpdateHandler(scope.row.id,'info')">详情</el-button>
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'修改')" type="primary" size="mini" @click="addOrUpdateHandler(scope.row.id)">修改</el-button>
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'物流')" type="info" size="mini" @click="logisticsUpdate(scope.row.id)">物流</el-button>
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'发货')" type="warning" size="mini" @click="updateHandler(scope.row)">发货</el-button>
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'确认收货')" type="success" size="mini" @click="updateHandler2(scope.row)">确认收货</el-button>
							<el-button v-if="isAuth('orders'+'/'+orderStatus,'删除')" type="danger" size="mini" @click="deleteHandler(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</div>

		<!-- 分页区域 -->
		<div class="pagination-section">
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				background
				:page-sizes="[10, 20, 30, 50]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalPage"
				:hide-on-single-page="false"
			></el-pagination>
		</div>

		<!-- 图片预览对话框 -->
		<el-dialog 
			title="图片预览" 
			:visible.sync="previewVisible" 
			width="600px"
			class="preview-dialog"
		>
			<img :src="previewImageUrl" style="width: 100%; height: auto;">
		</el-dialog>

		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>

		<!-- 日销量图表对话框 -->
		<el-dialog
		  title="日销量"
		  :visible.sync="dayNumberChartVisiable"
		  width="800">
			<div id="dayNumberChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="dayNumberChartDialog">返回</el-button>
		  </span>
		</el-dialog>

		<!-- 月销量图表对话框 -->
		<el-dialog
		  title="月销量"
		  :visible.sync="monthNumberChartVisiable"
		  width="800">
			<div id="monthNumberChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="monthNumberChartDialog">返回</el-button>
		  </span>
		</el-dialog>
		
		<!-- 年销量图表对话框 -->
		<el-dialog
		  title="年销量"
		  :visible.sync="yearNumberChartVisiable"
		  width="800">
			<div id="yearNumberChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="yearNumberChartDialog">返回</el-button>
		  </span>
		</el-dialog>
    
		<!-- 商品销量图表对话框 -->
		<el-dialog
		  title="商品销量"
		  :visible.sync="goodnameNumberChartVisiable"
		  width="800">
			<div id="goodnameNumberChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="goodnameNumberChartDialog">返回</el-button>
		  </span>
		</el-dialog>
		
		<!-- 类型销量图表对话框 -->
		<el-dialog
		  title="类型销量"
		  :visible.sync="goodtypeNumberChartVisiable"
		  width="800">
			<div id="goodtypeNumberChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="goodtypeNumberChartDialog">返回</el-button>
		  </span>
		</el-dialog>
    
		<!-- 日销额图表对话框 -->
		<el-dialog
		  title="日销额"
		  :visible.sync="dayAmountChartVisiable"
		  width="800">
			<div id="dayAmountChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="dayAmountChartDialog">返回</el-button>
		  </span>
		</el-dialog>
		
		<!-- 月销额图表对话框 -->
		<el-dialog
		  title="月销额"
		  :visible.sync="monthAmountChartVisiable"
		  width="800">
			<div id="monthAmountChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="monthAmountChartDialog">返回</el-button>
		  </span>
		</el-dialog>
    
		<!-- 年销额图表对话框 -->
		<el-dialog
		  title="年销额"
		  :visible.sync="yearAmountChartVisiable"
		  width="800">
			<div id="yearAmountChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="yearAmountChartDialog">返回</el-button>
		  </span>
		</el-dialog>
		
		<!-- 商品销额图表对话框 -->
		<el-dialog
		  title="商品销额"
		  :visible.sync="goodnameAmountChartVisiable"
		  width="800">
			<div id="goodnameAmountChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="goodnameAmountChartDialog">返回</el-button>
		  </span>
		</el-dialog>
		
		<!-- 类型销额图表对话框 -->
		<el-dialog
		  title="类型销额"
		  :visible.sync="goodtypeAmountChartVisiable"
		  width="800">
			<div id="goodtypeAmountChart" style="width:100%;height:600px;"></div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="goodtypeAmountChartDialog">返回</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        orderid: "",
        goodname: ""
      },
      previewVisible: false,
      previewImageUrl: "",
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      dayNumberChartVisiable: false,
      monthNumberChartVisiable: false,
      yearNumberChartVisiable: false,
      goodnameNumberChartVisiable: false,
      goodtypeNumberChartVisiable: false,
      dayAmountChartVisiable: false,
      monthAmountChartVisiable: false,
      yearAmountChartVisiable: false,
      goodnameAmountChartVisiable: false,
      goodtypeAmountChartVisiable: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],
      orderStatus: this.$route.params.status,
//导出excel
      json_fields: {
      "订单编号": "orderid",    //常规字段
      "商品表名": "tablename",    //常规字段
      "用户id": "userid",    //常规字段
      "商品id": "goodid",    //常规字段
      "商品名称": "goodname",    //常规字段
      "商品图片": "picture",    //常规字段
      "购买数量": "buynumber",    //常规字段
      "价格": "price",    //常规字段
      "折扣价格": "discountprice",    //常规字段
      "总价格": "total",    //常规字段
      "折扣总价格": "discounttotal",    //常规字段
      "支付类型": "type",    //常规字段
      "状态": "status",    //常规字段
      "地址": "address",    //常规字段
      "电话": "tel",    //常规字段
      "收货人": "consignee",    //常规字段
      "备注": "remark",    //常规字段
      "物流": "logistics",    //常规字段
      "商品类型": "goodtype",    //常规字段
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ]

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
//监听订单表参数是否变化，从而调取接口
  watch: {
  '$route' (to, from) { //监听路由是否变化
    if(this.$route.params.status){//判断状态是否有值
      //调数据
        this.orderStatus=this.$route.params.status;
        this.getDataList();
        this.contentStyleChange()
    }
  }
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orderid: "",
        goodname: ""
      };
      this.search();
    },
    
    // 获取表格序号
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none';
    },
    
    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.previewVisible = true;
    },
    
    // 获取支付方式标签类型
    getPaymentTagType(type) {
      switch (type) {
        case 1: return 'success';
        case 2: return 'warning';
        case 3: return 'info';
        default: return '';
      }
    },
    
    // 获取支付方式文本
    getPaymentText(type) {
      switch (parseInt(type)) {
        case 1: return '现金';
                        case 2: return '现金';
        case 3: return '拼团';
        default: return '未知';
      }
    },
    
    // 获取状态标签类型
    getStatusTagType(status) {
      switch (status) {
        case '未支付': return 'danger';
                        case '未发货': return 'warning';
        case '已发货': return 'info';
        case '已完成': return 'success';
        case '已取消': return 'info';
        case '已退款': return 'warning';
        default: return '';
      }
    },
    
    // 获取退款状态标签类型
    getRefundStatusTagType(refundStatus) {
      switch (refundStatus) {
        case '审核中': return 'warning';
        case '退款中': return 'danger';
        case '审核通过': return 'success';
        case '已退款': return 'success';
        case '拒绝退款': return 'danger';
        case '退款失败': return 'danger';
        case '已取消': return 'info';
        default: return '';
      }
    },

    orderStatusFormatter: function(row, column) {
      var temp = ''
      // 处理逻辑 保存接口 数据，进行匹配 name
      switch (row.type-0) {
        case 1:
          temp = '现金'
          break
        case 2:
                          temp = '现金'
          break
        case 3:
          temp = '拼团'
          break
      }
      return temp
    },
    updateHandler(row) {
      // 显示物流单号输入对话框
      this.showShippingDialog(row);
    },
    
    // 显示发货对话框
    showShippingDialog(row) {
      this.$confirm('', '发货确认', {
        confirmButtonText: '确定发货',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        message: `
          <div style="text-align: left; padding: 10px 0;">
            <div style="margin-bottom: 15px;">
              <label style="display: block; margin-bottom: 8px; font-weight: 600; color: #333;">选择配送方式：</label>
              <div style="display: flex; gap: 15px;">
                <label style="display: flex; align-items: center; cursor: pointer;">
                  <input type="radio" name="deliveryType" value="self_delivery" style="margin-right: 6px;" checked onchange="document.getElementById('logisticsFields').style.display='none'">
                  <span>商家自配送</span>
                </label>
                <label style="display: flex; align-items: center; cursor: pointer;">
                  <input type="radio" name="deliveryType" value="logistics" style="margin-right: 6px;" onchange="document.getElementById('logisticsFields').style.display='block'">
                  <span>物流运输</span>
                </label>
              </div>
            </div>
            <div id="logisticsFields" style="display: none; margin-bottom: 15px;">
              <div style="margin-bottom: 10px;">
                <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #333;">物流公司：</label>
                <input type="text" id="logisticsCompany" placeholder="请输入物流公司名称" style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px; box-sizing: border-box;">
              </div>
              <div>
                <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #333;">物流单号：</label>
                <input type="text" id="logisticsNumber" placeholder="请输入物流单号" style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px; box-sizing: border-box;">
              </div>
            </div>
          </div>
        `,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            const deliveryType = document.querySelector('input[name="deliveryType"]:checked').value;
            const logisticsCompany = document.getElementById('logisticsCompany').value;
            const logisticsNumber = document.getElementById('logisticsNumber').value;
            
            if (deliveryType === 'logistics') {
              if (!logisticsCompany.trim()) {
                this.$message.error('请输入物流公司名称');
                return;
              }
              if (!logisticsNumber.trim()) {
                this.$message.error('请输入物流单号');
                return;
              }
              if (logisticsNumber.trim().length < 3) {
                this.$message.error('物流单号至少需要3个字符');
                return;
              }
            }
            
            // 收集发货信息
            const shippingInfo = {
              deliveryType: deliveryType,
              logisticsCompany: logisticsCompany.trim(),
              logisticsNumber: logisticsNumber.trim()
            };
            
            // 确认发货
            this.confirmShipping(row, shippingInfo);
            done();
          } else {
            done();
          }
        }
      }).catch(() => {
        // 用户取消
        this.$message.info('已取消发货操作');
      });
    },
    
    // 确认发货
    confirmShipping(row, shippingInfo) {
      row.status = "已发货";
      
      // 根据配送方式设置相应字段
      if (shippingInfo.deliveryType === 'self_delivery') {
        // 商家自配送
        row.delivery_type = 'self_delivery';
        row.logistics_company = null;
        row.logistics_number = null;
        row.logistics = '商家自配送';
      } else {
        // 物流运输
        row.delivery_type = 'logistics';
        row.logistics_company = shippingInfo.logisticsCompany;
        row.logistics_number = shippingInfo.logisticsNumber;
        row.logistics = `${shippingInfo.logisticsCompany} - ${shippingInfo.logisticsNumber}`;
      }
      
      // 显示发货中状态
      this.$message({
        message: "正在发货并同步到微信小程序公众平台...",
        type: "info",
        duration: 2000
      });
      
      this.$http({
        url: `orders/update`,
        method: "post",
        data: row
      }).then(({ data }) => {
        if (data && data.code === 0) {
          let message = "发货成功";
          if (shippingInfo.deliveryType === 'logistics') {
            message += `，物流公司：${shippingInfo.logisticsCompany}，物流单号：${shippingInfo.logisticsNumber}`;
          } else {
            message += "，配送方式：商家自配送";
          }
          
          // 添加微信小程序同步提示
          message += "，已自动同步到微信小程序公众平台";
          
          this.$message({
            message: message,
            type: "success",
            duration: 4000,
            onClose: () => {
              this.search();
            }
          });
        } else {
           this.$message.error(data.msg);
        }
      }).catch(error => {
        console.error('发货操作失败:', error);
        this.$message.error('发货操作失败，请重试');
      });
    },
    updateHandler2(row) {
      this.$confirm(`确定已收货?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        row.status = "已完成";
        this.$http({
          url: `orders/update`,
          method: "post",
          data: row
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    //物流
    logisticsUpdate(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'logistics';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },

    dayNumberChartDialog() {
      this.dayNumberChartVisiable = !this.dayNumberChartVisiable;
      this.$nextTick(()=>{
        var dayNumberChart = echarts.init(document.getElementById("dayNumberChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/buynumber/日`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat(res[i].total));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '日销量',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    dayNumberChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        dayNumberChart.resize();
                    };
                }
            }
        });
      })
    },
    
    monthNumberChartDialog() {
      this.monthNumberChartVisiable = !this.monthNumberChartVisiable;
      this.$nextTick(()=>{
        var monthNumberChart = echarts.init(document.getElementById("monthNumberChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/buynumber/月`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat(res[i].total));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '月销量',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    monthNumberChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        monthNumberChart.resize();
                    };
                }
            }
        });
      })
    },
    
    yearNumberChartDialog() {
      this.yearNumberChartVisiable = !this.yearNumberChartVisiable;
      this.$nextTick(()=>{
        var yearNumberChart = echarts.init(document.getElementById("yearNumberChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/buynumber/年`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat(res[i].total));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '年销量',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    yearNumberChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        yearNumberChart.resize();
                    };
                }
            }
        });
      })
    },
    
    goodnameNumberChartDialog() {
      this.goodnameNumberChartVisiable = !this.goodnameNumberChartVisiable;
      this.$nextTick(()=>{
        var goodnameNumberChart = echarts.init(document.getElementById("goodnameNumberChart"),'macarons');
        this.$http({
            url: `orders/value/goodname/buynumber`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].goodname);
                    yAxis.push(parseFloat(res[i].total));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].goodname
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '商品销量',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    goodnameNumberChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        goodnameNumberChart.resize();
                    };
                }
            }
        });
      })
    },
    
    goodtypeNumberChartDialog() {
      this.goodtypeNumberChartVisiable = !this.goodtypeNumberChartVisiable;
      this.$nextTick(()=>{
        var goodtypeNumberChart = echarts.init(document.getElementById("goodtypeNumberChart"),'macarons');
        this.$http({
            url: `orders/value/goodtype/buynumber`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].goodtype);
                    yAxis.push(parseFloat(res[i].total));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].goodtype
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '类型销量',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    goodtypeNumberChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        goodtypeNumberChart.resize();
                    };
                }
            }
        });
      })
    },
    
    dayAmountChartDialog() {
      this.dayAmountChartVisiable = !this.dayAmountChartVisiable;
      this.$nextTick(()=>{
        var dayAmountChart = echarts.init(document.getElementById("dayAmountChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/total/日`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat((res[i].total)).toFixed(2));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '日销额',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    dayAmountChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        dayAmountChart.resize();
                    };
                }
            }
        });
      })
    },
    
    monthAmountChartDialog() {
      this.monthAmountChartVisiable = !this.monthAmountChartVisiable;
      this.$nextTick(()=>{
        var monthAmountChart = echarts.init(document.getElementById("monthAmountChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/total/月`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat((res[i].total)).toFixed(2));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '月销额',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    monthAmountChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        monthAmountChart.resize();
                    };
                }
            }
        });
      })
    },
    
    yearAmountChartDialog() {
      this.yearAmountChartVisiable = !this.yearAmountChartVisiable;
      this.$nextTick(()=>{
        var yearAmountChart = echarts.init(document.getElementById("yearAmountChart"),'macarons');
        this.$http({
            url: `orders/value/addtime/total/年`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].addtime);
                    yAxis.push(parseFloat((res[i].total)).toFixed(2));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].addtime
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '年销额',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    yearAmountChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        yearAmountChart.resize();
                    };
                }
            }
        });
      })
    },
    
    goodnameAmountChartDialog() {
      this.goodnameAmountChartVisiable = !this.goodnameAmountChartVisiable;
      this.$nextTick(()=>{
        var goodnameAmountChart = echarts.init(document.getElementById("goodnameAmountChart"),'macarons');
        this.$http({
            url: `orders/value/goodname/total`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].goodname);
                    yAxis.push(parseFloat((res[i].total)).toFixed(2));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].goodname
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '商品销额',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    goodnameAmountChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        goodnameAmountChart.resize();
                    };
                }
            }
        });
      })
    },
    
    goodtypeAmountChartDialog() {
      this.goodtypeAmountChartVisiable = !this.goodtypeAmountChartVisiable;
      this.$nextTick(()=>{
        var goodtypeAmountChart = echarts.init(document.getElementById("goodtypeAmountChart"),'macarons');
        this.$http({
            url: `orders/value/goodtype/total`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let res = data.data;
                let xAxis = [];
                let yAxis = [];
                let pArray = []
                for(let i=0;i<res.length;i++){
                    xAxis.push(res[i].goodtype);
                    yAxis.push(parseFloat((res[i].total)).toFixed(2));
                    pArray.push({
                    value: parseFloat((res[i].total)),
                    name: res[i].goodtype
                    })
                    var option = {};
                    option = {
                        tooltip: {
                          trigger: 'item',
                          formatter: '{b} : {c}'
                        },
                        title: {
                            text: '类型销额',
                            left: 'center'
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: yAxis,
                            type: 'bar'
                        }]
                    };
                    // 使用刚指定的配置项和数据显示图表。
                    goodtypeAmountChart.setOption(option);
                    //根据窗口的大小变动图表
                    window.onresize = function() {
                        goodtypeAmountChart.resize();
                    };
                }
            }
        });
      })
    },







    init () {
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
      
      // 只有当路由参数中有status且不为undefined/null时才添加status查询条件
      if (this.$route.params.status && this.$route.params.status !== 'undefined' && this.$route.params.status !== 'null') {
        params.status = this.$route.params.status;
      }
           if(this.searchForm.orderid!='' && this.searchForm.orderid!=undefined){
            params['orderid'] = '%' + this.searchForm.orderid + '%'
          }
           if(this.searchForm.goodname!='' && this.searchForm.goodname!=undefined){
            params['goodname'] = '%' + this.searchForm.goodname + '%'
          }
      console.log('订单列表查询参数:', params);
      this.$http({
        url: "orders/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        console.log('订单列表查询结果:', data);
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
          console.log('订单数据:', this.dataList);
        } else {
          this.dataList = [];
          this.totalPage = 0;
          console.error('订单查询失败:', data);
        }
        this.dataListLoading = false;
      }).catch(error => {
        console.error('订单查询异常:', error);
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "orders/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    
    // 同步到微信小程序公众平台
    syncToWechatMiniProgram() {
      // 获取已发货但可能未同步的订单
      const ordersToSync = this.dataList.filter(order => 
        order.status === '已发货' && 
        (order.delivery_type || order.logistics)
      );
      
      if (ordersToSync.length === 0) {
        this.$message.warning('没有找到需要同步的已发货订单');
        return;
      }
      
      this.$confirm(`确定将 ${ordersToSync.length} 个已发货订单同步到微信小程序公众平台吗？`, "同步确认", {
        confirmButtonText: "确定同步",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 显示同步进度
        this.$message({
          message: `正在同步 ${ordersToSync.length} 个订单到微信小程序公众平台...`,
          type: "info",
          duration: 2000
        });
        
        // 调用后端批量同步接口
        this.$http({
          url: "orders/batchSyncToWechat",
          method: "post",
          data: ordersToSync
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: `同步成功！成功同步 ${data.data.successCount} 个订单，失败 ${data.data.failCount} 个`,
              type: "success",
              duration: 5000,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg || '同步失败');
          }
        }).catch(error => {
          console.error('批量同步失败:', error);
          this.$message.error('批量同步失败，请重试');
        });
      });
    },


  }

};
</script>
<style lang="scss" scoped>
.orders-list-container {
	padding: 24px;
	background: #f5f7fa;
	min-height: 100vh;
}

// 页面头部
.page-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
	
	.header-left {
		display: flex;
		align-items: center;
	}
	
	.header-icon {
		width: 48px;
		height: 48px;
		background: linear-gradient(135deg, #3b82f6, #1e40af);
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 16px;
		
		svg {
			width: 24px;
			height: 24px;
			fill: white;
		}
	}
	
	.header-info {
		h1 {
			font-size: 24px;
			font-weight: 600;
			color: #1f2937;
			margin: 0 0 4px 0;
		}
		
		p {
			font-size: 14px;
			color: #6b7280;
			margin: 0;
		}
	}
	
	.header-actions {
		.el-button {
			padding: 12px 24px;
			font-size: 14px;
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 16px;
	
	.search-form {
		.el-form-item {
			margin-bottom: 0;
		}
		
		.input-wrapper {
			.input-field {
				position: relative;
				display: flex;
				align-items: center;
				
				.field-icon {
					position: absolute;
					left: 12px;
					top: 50%;
					transform: translateY(-50%);
					z-index: 1;
					
					svg {
						width: 16px;
						height: 16px;
						fill: #9ca3af;
					}
				}
				
				.el-input {
					width: 220px;
					
					/deep/ .el-input__inner {
						padding-left: 40px;
						border: 1px solid #d1d5db;
						border-radius: 8px;
						height: 40px;
						
						&:focus {
							border-color: #3b82f6;
							box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
						}
					}
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 16px;
	
	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		
		.selection-info {
			color: #3b82f6;
			font-weight: 500;
		}
	}
}

// 统计工具栏
.stats-toolbar {
	margin-bottom: 16px;
	
	.stats-content {
		.stats-actions {
			display: flex;
			gap: 8px;
			flex-wrap: wrap;
			
			.el-button {
				margin: 0;
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 16px;
	
	.table-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 20px;
		border-bottom: 1px solid #e5e7eb;
		
		h3 {
			margin: 0;
			font-size: 16px;
			font-weight: 600;
			color: #1f2937;
		}
	}
	
	.data-table {
		/deep/ .el-table__header {
			thead {
				tr {
					th {
						background: #f9fafb;
						border-bottom: 1px solid #e5e7eb;
						color: #374151;
						font-weight: 600;
					}
				}
			}
		}
		
		/deep/ .el-table__body {
			tbody {
				tr {
					&:hover {
						background: #f8fafc;
					}
					
					td {
						border-bottom: 1px solid #f3f4f6;
						padding: 12px 8px;
					}
				}
			}
		}
	}
}

// 订单信息
.order-info {
	display: flex;
	align-items: center;
	
	.order-icon {
		width: 32px;
		height: 32px;
		background: #dbeafe;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		
		svg {
			width: 16px;
			height: 16px;
			fill: #3b82f6;
		}
	}
	
	.order-details {
		.order-number {
			font-weight: 600;
			color: #1f2937;
			font-size: 14px;
		}
		
		.order-date {
			font-size: 12px;
			color: #6b7280;
			margin-top: 2px;
		}
	}
}

// 商品信息
.good-info {
	display: flex;
	align-items: center;
	
	.good-icon {
		width: 32px;
		height: 32px;
		background: #ecfdf5;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		
		svg {
			width: 16px;
			height: 16px;
			fill: #059669;
		}
	}
	
	.good-details {
		.good-name {
			font-weight: 500;
			color: #1f2937;
			font-size: 14px;
		}
		
		.good-type {
			font-size: 12px;
			color: #6b7280;
			margin-top: 2px;
		}
	}
}

// 商品图片
.product-image {
	position: relative;
	width: 80px;
	height: 60px;
	overflow: hidden;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f9fafb;
	margin: 0 auto;
	
	.image-preview {
		position: relative;
		width: 100%;
		height: 100%;
		cursor: pointer;
		
		.product-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		
		.image-overlay {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			transition: opacity 0.2s;
			
			i {
				color: white;
				font-size: 16px;
			}
		}
		
		&:hover .image-overlay {
			opacity: 1;
		}
	}
	
	.no-image {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #9ca3af;
		font-size: 12px;
		
		i {
			font-size: 20px;
			margin-bottom: 4px;
		}
	}
}

// 数量价格
.quantity-price {
	text-align: center;
	
	.quantity {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		color: #374151;
		margin-bottom: 4px;
		
		i {
			margin-right: 4px;
			color: #6b7280;
		}
	}
	
	.price {
		font-weight: 600;
		color: #ef4444;
		font-size: 14px;
		
		.price-symbol {
			font-size: 12px;
		}
	}
	
	.discount-price {
		font-size: 12px;
		color: #f59e0b;
		margin-top: 2px;
	}
}

// 总价
.total-price {
	text-align: center;
	
	.total {
		font-weight: 600;
		color: #dc2626;
		font-size: 16px;
	}
	
	.discount-total {
		font-size: 12px;
		color: #f59e0b;
		margin-top: 2px;
	}
}

// 支付标签
.payment-tag {
	font-weight: 500;
}

// 状态标签
.status-tag {
	font-weight: 500;
}

// 退款状态标签
.refund-status-tag {
	font-weight: 500;
}

// 收货信息
.shipping-info {
	.consignee, .phone, .address {
		display: flex;
		align-items: center;
		font-size: 13px;
		margin-bottom: 2px;
		
		i {
			margin-right: 6px;
			color: #6b7280;
			width: 12px;
		}
	}
	
	.consignee {
		font-weight: 500;
		color: #1f2937;
	}
	
	.phone {
		color: #374151;
	}
	
	.address {
		color: #6b7280;
	}
}

// 备注
.remark {
  color: #374151;
  font-size: 13px;
}

.no-remark {
  color: #9ca3af;
  font-style: italic;
  font-size: 13px;
}

// 配送信息
.delivery-info {
  .self-delivery {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #059669;
    font-size: 13px;
    
    i {
      color: #059669;
      font-size: 14px;
    }
    
    span {
      font-weight: 500;
    }
  }
  
  .logistics-info {
    .logistics-company {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #374151;
      font-size: 13px;
      margin-bottom: 4px;
      
      i {
        color: #6b7280;
        font-size: 12px;
      }
      
      span {
        font-weight: 500;
      }
    }
    
    .logistics-number {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #3b82f6;
      font-size: 13px;
      
      i {
        color: #3b82f6;
        font-size: 14px;
      }
      
      span {
        font-family: 'Courier New', monospace;
        font-weight: 500;
      }
    }
  }
  
  .no-delivery {
    color: #9ca3af;
    font-style: italic;
    font-size: 13px;
  }
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;
	margin-top: 24px;
	
	.el-pagination {
		/deep/ .el-pagination__total {
			color: #6b7280;
		}
		
		/deep/ .btn-prev, /deep/ .btn-next {
			background: white;
			border: 1px solid #d1d5db;
			
			&:hover {
				color: #3b82f6;
			}
		}
		
		/deep/ .el-pager li {
			background: white;
			border: 1px solid #d1d5db;
			margin: 0 4px;
			
			&.active {
				background: #3b82f6;
				border-color: #3b82f6;
			}
			
			&:hover {
				color: #3b82f6;
			}
		}
	}
}

// 图片预览对话框
.preview-dialog {
	/deep/ .el-dialog__body {
		padding: 0;
		text-align: center;
	}
}

// 导出excel
.export-excel-wrapper {
	display: inline-block;
}

// 响应式设计
@media (max-width: 768px) {
	.orders-list-container {
		padding: 16px;
	}
	
	.page-header {
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
	}
	
	.filter-section .search-form {
		.el-form-item {
			display: block;
			margin-bottom: 16px;
			
			.input-wrapper .input-field .el-input {
				width: 100%;
			}
		}
	}
	
	.stats-toolbar .stats-content .stats-actions {
		.el-button {
			font-size: 12px;
			padding: 8px 12px;
		}
	}
}
</style>
